__turbopack_context__.v({
  "ebBackgroundGlow": "m2yVwa_ebBackgroundGlow",
  "ebCanvas": "m2yVwa_ebCanvas",
  "ebCanvasContainer": "m2yVwa_ebCanvasContainer",
  "ebContent": "m2yVwa_ebContent",
  "ebGlow1": "m2yVwa_ebGlow1",
  "ebGlow2": "m2yVwa_ebGlow2",
  "ebLayers": "m2yVwa_ebLayers",
  "electricBorder": "m2yVwa_electricBorder",
  "root": "m2yVwa_root",
});
